import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import LoginApi from '../../api/auth/auth.api'
import { getToken, getUrl } from '../../utils/app.utils';
import axios from 'axios';

interface ProfileState {
  profile: UserProfile | null;
  loading: boolean;
  error: string;
}

interface Permission {
  code: string
  permit: boolean 
}

interface UserProfile {
  employeeFirstname: string
  employeeLastname: string
  permission: Permission[]

}


const initialState: ProfileState = {
  profile: null,
  loading: false,
  error: '',
};
export const profileAsync = createAsyncThunk<UserProfile>('profile', async () => {
  try {
    const url = await getUrl()
    const token = await getToken();

    const res = await LoginApi.getUser(token || '')
    // const res = await axios.get(url.REACT_APP_BASE_API + '/auth/profile',{
    //   headers: {
    //     Authorization: "Bearer " + localStorage.getItem('TOKEN'),
    //   },
    // });
    if (res?.data?.success) {

      return res.data.result;
    }
  } catch (error) {
    throw error;
  }
});

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    // You can add additional reducers here if needed.
  },
  extraReducers: (builder) => {
    builder
      .addCase(profileAsync.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(profileAsync.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.loading = false;
        state.error = '';
      })
      .addCase(profileAsync.rejected, (state: any, action) => {
        state.profile = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default profileSlice.reducer